import React, { FC } from "react";
import cn from "classnames";
import { Link } from "react-router-dom";

type Props = {
  active: boolean;
  icon?: React.ReactNode;
  label: string;
  to: string;
  target?: string;
  className?: string;
};

export const NavLink: FC<Props> = ({ active, to, icon, label, className, target }) => {
  return (
    <div className="px-3 mb-0.5">
      <Link
        to={to}
        target={target}
        className={cn(
          "flex items-center gap-2.5 px-2.5 py-2 rounded-lg text-[13px] font-medium transition-colors duration-150 relative group",
          {
            /* Active state */
            "bg-sidebar-active text-primary-700": active,
            /* Idle state */
            "text-ink-secondary hover:bg-sidebar-hover hover:text-ink": !active,
          },
          className
        )}
      >
        {/* Icon */}
        {icon && (
          <span
            className={cn("flex-shrink-0 transition-colors duration-150 [&>svg]:w-[18px] [&>svg]:h-[18px]", {
              "text-primary": active,
              "text-ink-muted group-hover:text-ink-secondary": !active,
            })}
          >
            {icon}
          </span>
        )}

        {/* Label */}
        <span className="truncate">{label}</span>
      </Link>
    </div>
  );
};
